import type { DriverBreakStatus } from '@/backend/market'
import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class DriverBreakFilterEntity {
  driver?: DriverEntity | null
  region?: RegionMiniEntity | null
  status?: DriverBreakStatus
  page?: number
  limit?: number
}
